/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */
/* eslint-disable no-shadow */
/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
import { Core, WebViewerInstance } from '@pdftron/webviewer';
import PDFAnnotationManager from 'components/PDFViewer/PDFAnnotationManager';
import PDFTronManager from 'components/PDFViewer/PDFTronManager';
import { WebViewerWrapper } from 'pdftron';
import AnnotationMixin from 'pdftron/docManager/Annotation';
import ToolsMixin from 'pdftron/docManager/Tools';
import PDFManagerFactory from 'pdftron/PDFManagerFactory';
import {
  app,
  getManualSelectedAnnotationId,
  getManualSelectedZoneId,
  getNextTextZoneId,
  getPageRangeSelector,
  getSelectedTool,
  getZoneSelectedTexts,
  inspection,
} from 'store';
import store from 'store/store';
import { DocumentTypes, PDFTRON_DEFAULT_TOOL, PDFTronTools, SelectedText, ZoneCustomData } from 'types';
import { resetAllNonSelectableFlags, shakeDocumentsZones } from './AnnotationTools';
import drawMarkupLabel from './utils/drawMarkupLabel';
import GVAnnotationMixin from './utils/GVAnnotationMixin';
import { PREP_TOOL_LABEL, PREP_TOOL_ANNOTATION } from './utils/annotationConstants';
import { getPageRotation } from './utils/labelPositionUtils';
import { annotationIsOutsideExistingCropZone, disableToolOutsideCropZones } from './utils/CropToolUtils';
import { useTextZoneStateStore } from 'zstore/useTextZoneStateStore';
import { useDocumentToastStateStore } from 'zstore/documentToastStateStore';
import { useMarqueeZoneStateStore } from 'zstore/marqueeZoneStore';
import { AnnotationCustomData } from 'types';
import { useZoomStateStore } from 'zstore/zoomStateStore';

class TextZone {
  source: WebViewerWrapper | null = null;

  target: WebViewerWrapper | null = null;

  constructor(source: WebViewerWrapper, target: WebViewerWrapper) {
    this.source = source;
    this.target = target;
  }

  get toolsMixin() {
    return new ToolsMixin(this.source, this.target);
  }

  get annotationMixin() {
    return new AnnotationMixin(this.source, this.target);
  }

  createZoneAnnotation(instance: WebViewerInstance) {
    class TextZoneAnnotation extends GVAnnotationMixin(instance.Core.Annotations.TextHighlightAnnotation) {
      constructor(zoneNumber: number | null = null, _override = false) {
        super();
        instance.Core.Tools.TextAnnotationCreateTool.AUTO_SET_TEXT = true; // this is so that getContents works as changed in pdftron 8.2+
        const state = store.getState();

        const manualSelectedZoneId = getManualSelectedZoneId(state);

        const manualSelectedAnnotationId = getManualSelectedAnnotationId(state);

        const sourceAddToZone = useTextZoneStateStore.getState().sourceAddToZone;
        const targetAddToZone = useTextZoneStateStore.getState().targetAddToZone;
        const addToZone = sourceAddToZone || targetAddToZone;
        if (addToZone) {
          this.Id = `${addToZone.id}_${Date.now()}`; // date is suffixed to make id unique
        }
        this.setCustomData(ZoneCustomData.confirmed, 'false');
        this.setCustomData(ZoneCustomData.zoneAnnotation, 'true');
        this.ToolName = PDFTronTools.ZONE;
        this.IsHoverable = true;
        if (sourceAddToZone) {
          this.setCustomData(ZoneCustomData.zoneId, `${sourceAddToZone.number}`);
        } else if (targetAddToZone) {
          this.setCustomData(ZoneCustomData.zoneId, `${targetAddToZone.number}`);
          this.ReadOnly = true;
        } else if (manualSelectedZoneId) {
          this.Id = `${manualSelectedAnnotationId}_${manualSelectedZoneId}`;
          this.setCustomData(ZoneCustomData.zoneId, `${manualSelectedZoneId}`);
          this.ReadOnly = true;
        } else {
          this.setCustomData(ZoneCustomData.zoneId, `${zoneNumber || getNextTextZoneId(state)}`);
        }
        this.ToolName = PDFTronTools.ZONE;
      }

      draw(ctx: CanvasRenderingContext2D, pageMatrix: any, pageRotation: number, zoomLevel: number) {
        const realPageRotation = getPageRotation(instance, this.PageNumber);
        this.setStyles(ctx, pageMatrix);
        this.StrokeColor = new instance.Core.Annotations.Color(241, 160, 153, 0.5);
        super.draw(ctx, pageMatrix, pageRotation, zoomLevel);
        ctx.save();

        const { DEFAULT_FILL_STYLE, SELECTED_FILL_STYLE } = PREP_TOOL_ANNOTATION;
        const selectedAnnotations = instance.Core.annotationManager.getSelectedAnnotations();
        const isSelected = selectedAnnotations.some((targetAnnot) => targetAnnot.Id.includes(this.Id));

        // we draw a rectangle for all selected zones except the selected source zone
        const isSelectedSourceZone =
          selectedAnnotations.length && !selectedAnnotations[0].ReadOnly && selectedAnnotations[0].Id === this.Id;

        const isConfirmed = this.getCustomData(ZoneCustomData.confirmed) === 'true';
        const isSearchCandidate = this.getCustomData(ZoneCustomData.zoneSearch) === 'true';
        const shouldDrawRectangle =
          selectedAnnotations?.[0]?.getCustomData(ZoneCustomData.zoneAnnotation) === 'true' &&
          selectedAnnotations?.[0]?.getCustomData(ZoneCustomData.zoneId) ===
            this.getCustomData(ZoneCustomData.zoneId) &&
          !isSelectedSourceZone &&
          // Do not draw rectangle for unconfirmed search candidates
          (isConfirmed || (isSearchCandidate && isSelected));

        if (shouldDrawRectangle) {
          // Draw red rectangle if the zone is selected
          const rectangle = new Path2D();
          rectangle.rect(this.X, this.Y, this.Width, this.Height);
          ctx.strokeStyle = SELECTED_FILL_STYLE;
          ctx.stroke(rectangle);
        }
        if (
          (this.getCustomData(ZoneCustomData.confirmed) === 'true' ||
            this.getCustomData(ZoneCustomData.zoneSearch) !== 'true') &&
          (isSelected || (this as any)?.IsHovering)
        ) {
          const fillStyle = isSelected ? SELECTED_FILL_STYLE : DEFAULT_FILL_STYLE;
          const zoneNumber = this.getCustomData(ZoneCustomData.zoneId);
          const labelText = `Text Zone: ${zoneNumber}`;
          const { HEIGHT, WIDTH_PADDING, GAP } = PREP_TOOL_LABEL;

          const pageWidth = instance.Core.documentViewer.getPageWidth(this.PageNumber);
          const pageHeight = instance.Core.documentViewer.getPageHeight(this.PageNumber);
          drawMarkupLabel(
            ctx,
            labelText,
            this.X,
            this.Y,
            HEIGHT,
            GAP,
            WIDTH_PADDING,
            fillStyle,
            zoomLevel,
            false,
            this.Width,
            this.Height,
            realPageRotation,
            pageWidth,
            pageHeight,
          );

          // For debug purposes
          // ctx.strokeStyle = '#000000';
          // ctx.strokeText(this.Id, this.Width / 2, this.Height / 2);
        }
      }
    }
    return TextZoneAnnotation;
  }

  createZoneAnnotationTools() {
    if (this.source && this.target) {
      [this.source, this.target].forEach((wrapper: WebViewerWrapper) => {
        const { instance } = wrapper;
        const toolObject = new (class ZoneCreateTool extends instance.Core.Tools.TextHighlightCreateTool {
          constructor(zoneAnnotation: any) {
            super(instance.Core.documentViewer);
            instance.Core.Tools.TextAnnotationCreateTool.call(this, instance.Core.documentViewer, zoneAnnotation);
          }
        })(this.createZoneAnnotation(instance));

        disableToolOutsideCropZones(toolObject, wrapper);

        wrapper.registerTool({
          toolName: PDFTronTools.ZONE,
          toolObject,
          buttonImage: '',
        });
      });
    }
  }

  dispatchOutsideCropToast() {
    store.dispatch(
      app.actions.setSnackMessage({
        message: 'Please select text within the crop or included pages.',
        type: 'error',
      }),
    );
  }

  textZoneAnnotationChanged(documentType: DocumentTypes, annotation: Core.Annotations.Annotation, action: string) {
    const isReload = action === 'add' && annotation.getCustomData(AnnotationCustomData.drawMarkups) === 'true';

    if (documentType === DocumentTypes.source) {
      const state = store.getState();
      const manualSelectedZoneId = getManualSelectedZoneId(state);
      switch (action) {
        case 'add': {
          if (annotationIsOutsideExistingCropZone(annotation, documentType)) {
            // Don't allow the new annotation
            this.dispatchOutsideCropToast();
            PDFAnnotationManager.deleteAnnotationById(documentType, annotation.Id);
            return;
          }

          if (!annotation.getContents()) {
            return;
          }

          // check that there arent' any unconfirmed zones
          const unconfirmedZones = this.source?.getAnnotationList((annot) => {
            // zone is not this annotation and it's unconfirmed
            return annot.Id !== annotation.Id && annot.getCustomData(ZoneCustomData.confirmed) === 'false';
          });
          if (unconfirmedZones && unconfirmedZones.length > 0) {
            store.dispatch(inspection.actions.setUnconfirmTextZoneError(true));
            PDFAnnotationManager.deleteAnnotationById(documentType, annotation.Id);
            return;
          }

          const sourceAddToZone = useTextZoneStateStore.getState().sourceAddToZone;
          if (sourceAddToZone) {
            // if it's add to zone we need to always set it as confirmed
            annotation.setCustomData(ZoneCustomData.confirmed, 'true');
            store.dispatch(
              inspection.actions.addZoneSelectedTexts({
                documentType,
                selectedText: annotation.getContents(),
                zoneId: sourceAddToZone.number.toString(),
                annotationId: annotation.Id,
              }),
            );
            store.dispatch(
              inspection.actions.setZoneSelected({
                zoneId: sourceAddToZone.number,
              }),
            );

            useTextZoneStateStore.getState().setSourceAddToZone(null);
            // store new annotations in redux and trigger autosave
            this.annotationMixin.updateInputAnnotations(true);
          } else if (!manualSelectedZoneId) {
            const zoneId = annotation.getCustomData(ZoneCustomData.zoneId);
            store.dispatch(
              inspection.actions.addZoneSelectedTexts({
                documentType,
                selectedText: annotation.getContents(),
                zoneId,
                annotationId: annotation.Id,
              }),
            );

            this.searchAnnotation(annotation, parseInt(zoneId, 10)).then((textTargetCount) => {
              if (textTargetCount === 1) {
                // Auto-confirm the single match
                const matched = this.target?.instance.Core.annotationManager
                  .getAnnotationsList()
                  .find(
                    (annot) =>
                      annot.Id.startsWith(`${annotation.Id}_`) &&
                      annot.getCustomData(ZoneCustomData.zoneAnnotation) === 'true',
                  );

                if (matched) {
                  matched.setCustomData(ZoneCustomData.confirmed, 'true');
                  matched.setCustomData(ZoneCustomData.zoneAnnotation, 'true');
                  matched.deleteCustomData(ZoneCustomData.zoneSearch);
                }

                // Confirm the source annotation
                annotation.setCustomData(ZoneCustomData.confirmed, 'true');

                // Select and autosave via setZoneSelected
                this.source?.instance.Core.annotationManager.selectAnnotation(annotation);
                store.dispatch(
                  inspection.actions.setZoneSelected({
                    zoneId: parseInt(zoneId, 10),
                  }),
                );
                this.annotationMixin.updateInputAnnotations(true);
              } else if (textTargetCount > 1) {
                // Multiple matches: do NOT auto-confirm; select first candidate
                const matchedAnnotations = this.target?.instance.Core.annotationManager
                  .getAnnotationsList()
                  .filter(
                    (annot) =>
                      annot.Id.includes(annotation.Id) &&
                      annot.ToolName === PDFTronTools.ZONE &&
                      annot.getCustomData(ZoneCustomData.zoneAnnotation) === 'true',
                  )
                  .sort((a, b) => a.PageNumber - b.PageNumber);

                const firstCandidate = matchedAnnotations && matchedAnnotations[0];
                if (firstCandidate) {
                  this.target?.instance.Core.annotationManager.jumpToAnnotation(firstCandidate);
                  this.target?.instance.Core.annotationManager.selectAnnotation(firstCandidate);
                }
              }
            });

            // Store new annotations in redux but do not trigger auto-save yet
            this.annotationMixin.updateInputAnnotations(false);
            store.dispatch(inspection.actions.increaseTextZoneId());
          } else {
            this.promptTextZoneCreation(DocumentTypes.source);
          }
          break;
        }
        case 'modify': {
          if (documentType === DocumentTypes.source) {
            this.modifyZoneAnnotation(annotation);
          } else {
            this.modifyZoneSearch(annotation);
          }
          this.annotationMixin.updateInputAnnotations(false);
          break;
        }
      }
    } else {
      if (action === 'add') {
        // Skip autosave and selection flow for search-generated candidates on target
        if (annotation.getCustomData(ZoneCustomData.zoneSearch) === 'true') {
          return;
        }

        // Add-to-zone on target is not a search result; mark as confirmed immediately
        annotation.setCustomData(ZoneCustomData.confirmed, 'true');
        annotation.setCustomData(ZoneCustomData.zoneAnnotation, 'true');

        // get matching source zone
        const zoneId = annotation.getCustomData(ZoneCustomData.zoneId);
        const sourceZones = this.source?.getAnnotationList().filter((annotation) => {
          return (
            annotation.ToolName === PDFTronTools.ZONE && annotation.getCustomData(ZoneCustomData.zoneId) === zoneId
          );
        });
        if (sourceZones && sourceZones.length > 0) {
          sourceZones.forEach((sourceZone) => {
            sourceZone.setCustomData(ZoneCustomData.confirmed, 'true');
            const groupId = sourceZone.getCustomData(ZoneCustomData.zoneGroup);
            if (groupId) {
              annotation.setCustomData(ZoneCustomData.zoneGroup, groupId);
            }
          });
          // expire the source zone
          const { expireAllToast } = useDocumentToastStateStore.getState();
          expireAllToast();

          const sourceZoneId =
            sourceZones[0]?.getCustomData(ZoneCustomData.zoneId) ||
            getManualSelectedZoneId(store.getState()).toString();
          store.dispatch(
            inspection.actions.addZoneSelectedTexts({
              documentType,
              selectedText: annotation.getContents(),
              zoneId: sourceZoneId,
              annotationId: annotation.Id,
            }),
          );
        }
        resetAllNonSelectableFlags();

        // Only dispatch setZoneSelected for user changes, not reloads
        // setZoneSelected is in the autoSaveActions list and always triggers autosave
        if (!isReload) {
          // select the target annotation
          this.target?.instance.Core.annotationManager.selectAnnotation(annotation);
          store.dispatch(
            inspection.actions.setZoneSelected({
              zoneId: parseInt(zoneId, 10),
            }),
          );
          this.promptTextZoneCreation(DocumentTypes.source);
          if (getSelectedTool(store.getState()) === PDFTronTools.ZONE) {
            this.annotationMixin.updateInputAnnotations(true);
          }
        }
        // always deactivate manual selection and clean up add to zone state
        useTextZoneStateStore.getState().setTargetAddToZone(null);
        store.dispatch(inspection.actions.deactivateManualSelection());
      }
    }
  }

  modifyZoneSearch(modifiedAnnotation: Core.Annotations.Annotation) {
    const annotationId = modifiedAnnotation.Id.split('_')[0];
    store.dispatch(
      inspection.actions.modifySearchedZone({ annotationId, searchedText: modifiedAnnotation.getContents() }),
    );
  }

  modifyZoneAnnotation(annotation: Core.Annotations.Annotation) {
    const zoneId = annotation.getCustomData(ZoneCustomData.zoneId);
    store.dispatch(
      inspection.actions.modifySelectedZone({ zoneId: zoneId.toString(), selectedText: annotation.getContents() }),
    );
    const targetAnnoManager = PDFAnnotationManager.getInstance(DocumentTypes.target);
    const state = store.getState();
    const zoneSelectedArr: Array<SelectedText> = getZoneSelectedTexts(state);
    const editedZone = zoneSelectedArr.find((zone) => zone.annotationId === annotation.Id);
    const annotationToBeDeleted: Array<Core.Annotations.Annotation> = [];
    if (editedZone && targetAnnoManager) {
      editedZone.searchedAnnotations.forEach((zone) => {
        const annotation = targetAnnoManager.getAnnotationById(zone.annotationId);
        annotation.ReadOnly = true; // this is to avoid triggering the default adding action of ZoneSearchEventHandler
        annotation.setCustomData(ZoneCustomData.zoneSearch, 'true');
        annotationToBeDeleted.push(annotation);
      });
    }

    // remove the old searched result and reset the selected status
    store.dispatch(inspection.actions.deleteUnselectedText({ annotationId: '', zoneId: parseInt(zoneId, 10) }));
    store.dispatch(inspection.actions.setZoneUnselected({ zoneId: parseInt(zoneId, 10) }));

    annotationToBeDeleted.forEach((annotation) => {
      PDFAnnotationManager.deleteHighlightAnnotations(DocumentTypes.target, annotation.Id);
    });

    // new search
    this.searchAnnotation(annotation, parseInt(zoneId, 10));
    annotation.setCustomData(ZoneCustomData.confirmed, 'false');
  }

  textZoneAnnotationSelected(documentType: DocumentTypes, annotation: Core.Annotations.Annotation, action: string) {
    if (!this.source || !this.target) return;

    // Preventing doulbe unlinking
    if (annotation.getCustomData(ZoneCustomData.nonSelectable) === 'true') {
      // reset the annotationPopup to the default
      if (documentType === DocumentTypes.source) {
        this.source.instance.UI.annotationPopup.update([]);
        this.source.instance.Core.annotationManager.deselectAnnotation(annotation);
      } else {
        this.target.instance.UI.annotationPopup.update([]);
        this.target.instance.Core.annotationManager.deselectAnnotation(annotation);
      }

      // find any unconfirmed text zone first
      const sourceAnnotations = this.source.instance.Core.annotationManager.getAnnotationsList();
      const textUnconfirmedZones = sourceAnnotations.filter((annot) => {
        return (
          annot.ToolName === PDFTronTools.ZONE &&
          annot.getCustomData(ZoneCustomData.confirmed) === 'false' &&
          annot.Id !== annotation.Id // it's not the one I'm selecting
        );
      });
      // or fallback to pending marquee zone if any
      const pendingMarqueeZone = useMarqueeZoneStateStore.getState().pendingTargetMarqueeZoneNumber;
      const marqueeUnconfirmedZones = pendingMarqueeZone
        ? this.source.instance.Core.annotationManager
            .getAnnotationsList()
            .filter(
              (annot) =>
                annot.ToolName === PDFTronTools.MARQUEE_ZONE &&
                parseInt(annot.getCustomData('zoneId'), 10) === pendingMarqueeZone,
            )
        : [];

      // select it so it's clear for the user that the zone is unlinked
      if (textUnconfirmedZones.length > 0) {
        setTimeout(() => {
          this.source?.instance.Core.annotationManager.selectAnnotation(textUnconfirmedZones[0]);
        }, 100);
        const zoneId = textUnconfirmedZones[0].getCustomData(ZoneCustomData.zoneId);
        this.promptTextZoneCreation(DocumentTypes.target);
        store.dispatch(
          inspection.actions.activateManualSelection({
            annotationId: textUnconfirmedZones[0].Id,
            zoneId: parseInt(zoneId, 10),
          }),
        );
      } else if (marqueeUnconfirmedZones.length > 0) {
        setTimeout(() => {
          this.source?.instance.Core.annotationManager.selectAnnotation(marqueeUnconfirmedZones[0]);
        }, 100);
        const zoneId = parseInt(marqueeUnconfirmedZones[0].getCustomData('zoneId'), 10);
        // Switch prompt to marquee flow
        const marquee = (PDFManagerFactory as any)?.getPDFDocManager?.()?.getMarqueeZone?.();
        if (marquee?.promptMarqueeZoneCreation) {
          marquee.promptMarqueeZoneCreation(DocumentTypes.target);
        } else {
          PDFTronManager.setToolMode(PDFTronTools.MARQUEE_ZONE, zoneId);
        }
        store.dispatch(
          inspection.actions.activateManualSelection({
            annotationId: marqueeUnconfirmedZones[0].Id,
            zoneId,
          }),
        );
      }
      return;
    }

    this.zoomToZoneSelection(documentType, annotation);

    if (documentType === DocumentTypes.source) {
      this.source.instance.UI.annotationPopup.update([this.getDeleteZonePopup(this.source.instance)]);
      if (annotation.getCustomData(ZoneCustomData.confirmed) === 'true') {
        this.source.instance.UI.annotationPopup.update([
          this.getAddToTextZonePopup(DocumentTypes.source, this.source.instance),
          this.getDeleteZonePopup(this.source.instance),
        ]);
      } else {
        this.source.instance.UI.annotationPopup.update([this.getDeleteZonePopup(this.source.instance)]);
      }

      const zoneNumberString = parseInt(annotation.getCustomData(ZoneCustomData.zoneId), 10).toString();
      // select the other source annotations in the same zone
      const sourceAnnotationsToSelect = this.source.instance.Core.annotationManager
        .getAnnotationsList()
        .filter(
          (annot) =>
            annot.ToolName === PDFTronTools.ZONE &&
            annot.getCustomData(ZoneCustomData.zoneId) === zoneNumberString &&
            annot.getCustomData(ZoneCustomData.nonSelectable) !== 'true' &&
            !this.source?.instance.Core.annotationManager.isAnnotationSelected(annot),
        );

      if (sourceAnnotationsToSelect?.length) {
        this.source.instance.Core.annotationManager.selectAnnotations(sourceAnnotationsToSelect);
      }

      const targetAnnotations = this.target.instance.Core.annotationManager.getAnnotationsList();

      // the corresponding target annotations from the selected source zone
      const mirrorAnnotations = targetAnnotations
        .filter(
          (targetAnnotation) =>
            targetAnnotation.ToolName === PDFTronTools.ZONE &&
            targetAnnotation.getCustomData(ZoneCustomData.zoneId) === zoneNumberString &&
            !this.target?.instance.Core.annotationManager.isAnnotationSelected(targetAnnotation),
        )
        .sort((annotationA, annotationB) => annotationA.PageNumber - annotationB.PageNumber); // sort the annotations in case that this is called on add to select to the topmost target annotation

      const selectedAnnotations = this.target.instance.Core.annotationManager.getSelectedAnnotations();
      // make sure the target annotation is not already selected to prevent an infinite loop on selection event handlers

      const isAlreadySelected = selectedAnnotations.some(
        (targetAnnot) =>
          targetAnnot.getCustomData(ZoneCustomData.zoneId) === zoneNumberString &&
          targetAnnot.getCustomData(ZoneCustomData.zoneAnnotation) === 'true',
      );

      // if the target annotation isnt selected, jump to the confirmed or TOPMOST unconfirmed matching annotation
      if (!isAlreadySelected && mirrorAnnotations && mirrorAnnotations[0]) {
        this.target?.instance.Core.annotationManager.jumpToAnnotation(mirrorAnnotations[0]);
        this.target?.instance.Core.annotationManager.selectAnnotation(mirrorAnnotations[0]);
      }
    } else {
      // selected zone annotation is on target document
      const { instance } = this.target;

      if (annotation.getCustomData(ZoneCustomData.confirmed) === 'true') {
        // enable unmatch button on confirmed zones in target document
        const popupButtons = [
          this.getAddToTextZonePopup(DocumentTypes.target, this.target.instance),
          this.getUnmatchPopup(this.target.instance),
        ];

        // Check if this annotation is part of a group
        const zoneGroupId = annotation.getCustomData(ZoneCustomData.zoneGroup);
        if (zoneGroupId) {
          const allAnnotations = instance.Core.annotationManager.getAnnotationsList().filter((a) => {
            const isInGroup = a.getCustomData(ZoneCustomData.zoneGroup) === zoneGroupId;
            const isConfirmed = a.getCustomData(ZoneCustomData.confirmed) === 'true';
            return isInGroup && isConfirmed;
          });

          // handle edge case where zone belongs to a group, but theres only one zone in the group after others were deleted
          if (allAnnotations.length > 1) {
            popupButtons.push(this.getPreviousMatchPopup(false));
            popupButtons.push(this.getNextMatchPopup(false));
          }
        }

        this.target.instance.UI.annotationPopup.update(popupButtons);
      } else {
        const baseId = annotation.Id.split('_')[0];
        const multipleCandidates = this.getMultipleSearchResults(baseId);
        const popupButtons = [];
        if (multipleCandidates.length > 1) {
          popupButtons.push(this.getConfirmTextZonePopup(this.target.instance));
          popupButtons.push(this.getConfirmAllTextZonePopup(multipleCandidates));
          popupButtons.push(this.getPreviousMatchPopup(false));
          popupButtons.push(this.getNextMatchPopup(false));
        } else {
          popupButtons.push(this.getManualSelectPopup(this.target.instance));
          popupButtons.push(this.getConfirmTextZonePopup(this.target.instance));
        }
        this.target.instance.UI.annotationPopup.update(popupButtons);
      }

      const zoneNumberString = annotation.getCustomData(ZoneCustomData.zoneId);
      // get the matching source zone by id
      const sourceAnnotations = this.source.instance.Core.annotationManager
        .getAnnotationsList()
        .filter(
          (annot) =>
            annot.ToolName === PDFTronTools.ZONE && annot.getCustomData(ZoneCustomData.zoneId) === zoneNumberString,
        );

      const firstSourceAnnotation = sourceAnnotations?.[0];

      // jump and select matching source annotation if its not already selected by loop
      if (
        firstSourceAnnotation &&
        !this.target.instance.Core.annotationManager.isAnnotationSelected(firstSourceAnnotation)
      ) {
        this.source?.instance.Core.annotationManager.jumpToAnnotation(firstSourceAnnotation);
        this.source?.instance.Core.annotationManager.selectAnnotations(sourceAnnotations);
      }
    }
  }

  private zoomToZoneSelection(documentType: DocumentTypes, annotation: Core.Annotations.Annotation) {
    const zoneId = annotation.getCustomData(ZoneCustomData.zoneId);
    const { zoomLockLevel, setZoomChanging } = useZoomStateStore.getState();

    this[documentType]?.setDifferenceZoomLevel(annotation, !!zoomLockLevel[documentType]);
    this[documentType]?.jumpToAnnotation(annotation.Id);
    setZoomChanging();

    const oppositeDocument = documentType === DocumentTypes.source ? DocumentTypes.target : DocumentTypes.source;

    // Resolve opposite-side annotation
    const candidates = this[oppositeDocument]
      ?.getAnnotationList()
      .filter(
        (a) =>
          a.ToolName === PDFTronTools.ZONE &&
          a.getCustomData(ZoneCustomData.zoneId) === zoneId &&
          a.getCustomData(ZoneCustomData.nonSelectable) !== 'true',
      );
    if (candidates && candidates.length === 1) {
      const candidate = candidates[0];
      this[oppositeDocument]?.setDifferenceZoomLevel(candidate, !!zoomLockLevel[oppositeDocument]);
      this[oppositeDocument]?.jumpToAnnotation(candidate.Id);
      setZoomChanging();
    }
  }

  async searchAnnotation(newAnnotation: Core.Annotations.Annotation, zoneId: number): Promise<number> {
    const textTargetCount = await PDFTronManager.searchTextTarget(
      newAnnotation.getContents(),
      newAnnotation.Id,
      zoneId,
    ); // @todo refactor this to get rid of PDFTronManager
    const hasResult = textTargetCount > 0;
    if (!hasResult) {
      store.dispatch(inspection.actions.setHasResult({ zoneId: zoneId.toString(), hasResult }));
      store.dispatch(inspection.actions.setNoResultAnnotationId(newAnnotation.Id));
      newAnnotation.setCustomData('noResult', 'true');
      return 0;
    }
    return textTargetCount;
  }

  getMultipleSearchResults(annotationId: string): Core.Annotations.Annotation[] {
    let annots: Core.Annotations.Annotation[] = [];
    if (this.target) {
      annots = this.target.instance.Core.annotationManager.getAnnotationsList().filter((annotation) => {
        return (
          annotation.Id.includes(annotationId.split('_')[0]) &&
          annotation.getCustomData(ZoneCustomData.confirmed) !== 'true' &&
          annotation.getCustomData(ZoneCustomData.zoneSearch) === 'true'
        );
      });
    }

    return annots;
  }

  getConfirmTextZonePopup(instance: WebViewerInstance) {
    return {
      type: 'actionButton',
      img: '/icons/confirmZonings.svg',
      title: 'Confirm only this zone',
      onClick: () => {
        const selectedAnnotation = instance.Core.annotationManager.getSelectedAnnotations()[0];
        // Don't allow confirmation if the selected annotation is outside a crop zone
        if (annotationIsOutsideExistingCropZone(selectedAnnotation, DocumentTypes.target)) {
          this.dispatchOutsideCropToast();
          return;
        }

        const selectedAnnotationId = selectedAnnotation.Id;
        selectedAnnotation.setCustomData(ZoneCustomData.confirmed, 'true');
        const targetAnnoManager = PDFAnnotationManager.getInstance(DocumentTypes.target);
        const sourceAnnoManager = PDFAnnotationManager.getInstance(DocumentTypes.source);

        const zoneAnnotation = sourceAnnoManager?.getAnnotationById(selectedAnnotationId.split('_')[0]);
        zoneAnnotation?.setCustomData(ZoneCustomData.confirmed, 'true');

        const annotationToBeDeleted = instance.Core.annotationManager
          .getAnnotationsList()
          .filter((annotation) => annotation.Id.split('_')[0] === selectedAnnotationId.split('_')[0])
          .filter((annotation) => annotation.Id !== selectedAnnotationId);

        annotationToBeDeleted.forEach((annotation) => {
          PDFAnnotationManager.deleteHighlightAnnotations(DocumentTypes.target, annotation.Id);
        });
        store.dispatch(
          inspection.actions.deleteUnselectedText({
            annotationId: selectedAnnotationId,
            zoneId: parseInt(selectedAnnotation.getCustomData(ZoneCustomData.zoneId), 10),
          }),
        );
        store.dispatch(
          inspection.actions.setZoneSelected({
            zoneId: parseInt(selectedAnnotation.getCustomData(ZoneCustomData.zoneId), 10),
          }),
        );
        targetAnnoManager?.selectAnnotation(selectedAnnotation);
        // Updates annotations in redux
        this.annotationMixin.updateInputAnnotations();

        // This ensures zones are properly numbered after unmatching a text zone with multiple matches and confirming a single zone
        shakeDocumentsZones(selectedAnnotation);
        store.dispatch(inspection.actions.resetZoneId());

        this.source?.addDocumentHighlight();
        this.target?.removeAnnotationDocumentHighlight();
      },
    };
  }

  getConfirmAllTextZonePopup(multipleCandidates: Core.Annotations.Annotation[]) {
    return {
      type: 'actionButton',
      img: '/icons/confirmAllZonings.svg',
      title: `Confirm All ${multipleCandidates.length} Zones`,
      onClick: () => {
        this.confirmAll(multipleCandidates);
      },
    };
  }

  confirmAll(multipleCandidates: Core.Annotations.Annotation[]) {
    // selected annotation on the target doc
    if (!this.target?.instance || !this.source?.instance) return;
    const targetSelected = this.target.instance.Core.annotationManager.getSelectedAnnotations()[0];
    if (!targetSelected) return;
    const pageRange = getPageRangeSelector(store.getState());

    const baseId = targetSelected?.Id?.split('_')[0];

    const sourceAnnotation = this.source.instance.Core.annotationManager.getAnnotationById(baseId);
    if (!sourceAnnotation) return;

    // check if the source annotation is in the page range
    if (pageRange.source.length > 0 && !pageRange.source.includes(sourceAnnotation.PageNumber)) {
      this.dispatchOutsideCropToast();
      return;
    }

    // function to check if the target annotation is in the page range
    const isInPageRange = (pageNumber: number) => pageRange.target.includes(pageNumber);

    // Don't allow confirmation if the selected annotation is outside a crop zone
    if (
      annotationIsOutsideExistingCropZone(targetSelected, DocumentTypes.target) ||
      !isInPageRange(targetSelected.PageNumber)
    ) {
      this.dispatchOutsideCropToast();
      return;
    }

    // Partition into in-crop and out-of-crop candidates
    const partitioned = multipleCandidates.reduce(
      (
        acc: { inCrop: Core.Annotations.Annotation[]; outCrop: Core.Annotations.Annotation[] },
        candidate: Core.Annotations.Annotation,
      ) => {
        if (
          annotationIsOutsideExistingCropZone(candidate, DocumentTypes.target) ||
          !isInPageRange(candidate.PageNumber)
        ) {
          acc.outCrop.push(candidate);
        } else {
          acc.inCrop.push(candidate);
        }
        return acc;
      },
      { inCrop: [], outCrop: [] },
    );
    const inCropTargetAnnotations = partitioned.inCrop;
    const outCropTargetAnnotations = partitioned.outCrop;

    // Remove all out-of-crop candidates immediately
    if (outCropTargetAnnotations.length) {
      this.target.instance.Core.annotationManager.deleteAnnotations(outCropTargetAnnotations, {
        imported: true,
        force: true,
      });
    }

    // If none remain inside crop, cleanup source and Redux and exit
    if (inCropTargetAnnotations.length === 0) {
      // delete source annotation if there are no in crop target annotations
      this.source.instance.Core.annotationManager.deleteAnnotation(sourceAnnotation, {
        imported: true,
        force: true,
      });

      store.dispatch(
        inspection.actions.deleteSelectedZone({
          documentType: DocumentTypes.source,
          annotationId: baseId,
        }),
      );
      store.dispatch(
        inspection.actions.deleteSelectedText({
          documentType: DocumentTypes.source,
          annotationId: baseId,
        }),
      );

      this.annotationMixin.updateInputAnnotations();
      shakeDocumentsZones(targetSelected);
      this.dispatchOutsideCropToast();
      return;
    }

    const sourceAnnoManager = PDFAnnotationManager.getInstance(DocumentTypes.source);
    const documentWrapper = PDFManagerFactory.getViewer(DocumentTypes.source);
    if (!documentWrapper) return;

    const instanceSource = documentWrapper?.instance;
    const instanceTarget = this.target.instance;
    const targetAnnoManager = PDFAnnotationManager.getInstance(DocumentTypes.target);

    const zoneSelectedTexts = getZoneSelectedTexts(store.getState());
    const originalZoneSelectedText = zoneSelectedTexts.find((zoneText) => zoneText.annotationId === baseId);

    if (!originalZoneSelectedText) return;

    // text will be used to create new selected text zones but the zone itself can be deleted now
    const originalZoneText = originalZoneSelectedText.text;
    store.dispatch(
      inspection.actions.deleteSelectedText({
        documentType: DocumentTypes.source,
        annotationId: originalZoneSelectedText.annotationId,
      }),
    );

    // the first zone should be the same as the source annotation
    let zoneId = parseInt(sourceAnnotation.getCustomData(ZoneCustomData.zoneId), 10);

    // delete the source annotation it will be recreated later
    this.source.instance.Core.annotationManager.deleteAnnotation(sourceAnnotation, {
      imported: true,
      force: true,
    });

    // Generate a unique group ID for this set of zones
    const zoneGroupId = `group_${Date.now()}`;

    // get all source annotations (we'll use this to find next available zone id)
    const sourceAnnotations = this.source.instance.Core.annotationManager.getAnnotationsList();

    // for each element in target annotations inside crop, create a new source annotation and confirm target
    let firstConfirmedTarget: Core.Annotations.Annotation | null = null;
    for (const annotation of inCropTargetAnnotations) {
      const newAnnotation = new (this.createZoneAnnotation(instanceSource))();
      newAnnotation.PageNumber = sourceAnnotation.PageNumber;
      const sourceQuads = this.getQuadsSafe(sourceAnnotation);
      newAnnotation.Quads = sourceQuads;

      // -1 because the id was already incremented when the original source annotation was created
      newAnnotation.setCustomData(ZoneCustomData.zoneId, `${zoneId}`);
      newAnnotation.setCustomData(ZoneCustomData.confirmed, 'true');
      // Add group ID to link related zones
      newAnnotation.setCustomData(ZoneCustomData.zoneGroup, zoneGroupId);

      // Create a fresh confirmed target annotation mapped to the new source annotation
      const newTargetAnnot = new (this.createZoneAnnotation(instanceTarget))();
      newTargetAnnot.PageNumber = annotation.PageNumber;
      const targetQuads = this.getQuadsSafe(annotation);
      newTargetAnnot.Quads = targetQuads;
      newTargetAnnot.Id = `${newAnnotation.Id}_${annotation.getPageNumber()}-0`;
      newTargetAnnot.setCustomData(ZoneCustomData.zoneId, `${zoneId}`);
      newTargetAnnot.setCustomData(ZoneCustomData.confirmed, 'true');
      newTargetAnnot.setCustomData(ZoneCustomData.zoneAnnotation, 'true');
      newTargetAnnot.setCustomData(ZoneCustomData.zoneGroup, zoneGroupId);
      newTargetAnnot.deleteCustomData(ZoneCustomData.zoneSearch);
      targetAnnoManager?.addAnnotation(newTargetAnnot);
      // Remove the original search candidate
      targetAnnoManager?.deleteAnnotation(annotation, { imported: true, force: true });

      sourceAnnoManager?.addAnnotation(newAnnotation);

      // we need to create new selected text zones for each annotation so they will be correctly added to the inspection input
      store.dispatch(
        inspection.actions.addZoneSelectedTexts({
          documentType: DocumentTypes.source,
          selectedText: originalZoneText,
          zoneId: `${zoneId}`,
          annotationId: newAnnotation.Id,
          selected: true,
        }),
      );
      store.dispatch(
        inspection.actions.addZoneSearchedAnnotation({
          searchedAnnotation: {
            annotationId: newTargetAnnot.Id,
            text: originalZoneText,
            zoneId,
          },
        }),
      );
      if (!firstConfirmedTarget) firstConfirmedTarget = newTargetAnnot;
      // appending the new annotation created since it won't be added to the source annotations list
      sourceAnnotations.push(newAnnotation);
      // find next available zone id
      const lastUsedZoneId = sourceAnnotations.reduce((max, annotation) => {
        const currentZoneId = parseInt(annotation.getCustomData(ZoneCustomData.zoneId), 10);
        return Math.max(max, currentZoneId);
      }, 0);
      zoneId = lastUsedZoneId + 1;
    }

    PDFAnnotationManager.deleteHighlightAnnotations(DocumentTypes.source, baseId);

    // Updates annotations in redux
    this.annotationMixin.updateInputAnnotations(false);

    // This ensures zones are properly numbered after unmatch -> confirm all
    shakeDocumentsZones(targetSelected);
    store.dispatch(inspection.actions.resetZoneId());

    // Select only the first confirmed annotation (inside crop)
    const firstAnnotation = firstConfirmedTarget;
    if (firstAnnotation) {
      // Ensure no multi-selection remains from previous state
      this.target.instance.Core.annotationManager.deselectAllAnnotations();
      this.target.instance.Core.annotationManager.selectAnnotation(firstAnnotation);
      this.target.instance.Core.annotationManager.jumpToAnnotation(firstAnnotation);
    }

    this.source?.addDocumentHighlight();
    this.target?.removeAnnotationDocumentHighlight();
    this.annotationMixin.updateInputAnnotations();
  }

  getManualSelectPopup(instance: WebViewerInstance) {
    return {
      type: 'actionButton',
      img: '/icons/edit.svg',
      title: 'Edit',
      onClick: () => {
        const selectedAnnotation = instance.Core.annotationManager.getSelectedAnnotations()[0];
        const selectedAnnotationId = selectedAnnotation?.Id || '';
        const zoneAnnotation = this.source?.instance.Core.annotationManager.getAnnotationById(
          selectedAnnotationId.split('_')[0],
        );

        const annotationToBeDeleted = instance.Core.annotationManager
          .getAnnotationsList()
          .filter((annotation) => annotation.Id.split('_')[0] === zoneAnnotation?.Id);

        store.dispatch(
          inspection.actions.activateManualSelection({
            annotationId: selectedAnnotationId,
            zoneId: parseInt(selectedAnnotation?.getCustomData(ZoneCustomData.zoneId), 10),
          }),
        );
        annotationToBeDeleted.forEach((annotation) => {
          PDFAnnotationManager.deleteHighlightAnnotations(DocumentTypes.target, annotation.Id);
        });
        store.dispatch(
          inspection.actions.deleteUnselectedText({
            annotationId: '',
            zoneId: parseInt(selectedAnnotation?.getCustomData(ZoneCustomData.zoneId), 10),
          }),
        );

        this.promptTextZoneCreation(DocumentTypes.target);

        // change panel highlight from source to target to indicate target document zone selection
        // @TODO Is this a flaw of mixins ????? - we can't get this from this.source / this.target
        PDFManagerFactory.getViewer(DocumentTypes.source)?.removeAnnotationDocumentHighlight();
        PDFManagerFactory.getViewer(DocumentTypes.target)?.addDocumentHighlight();
        this.annotationMixin.updateInputAnnotations();
      },
    };
  }

  getUnmatchPopup(instance: WebViewerInstance) {
    return {
      type: 'actionButton',
      img: '/icons/unmatchZonings.svg',
      title: 'Unmatch',
      onClick: async () => {
        const selectedAnnotation = instance.Core.annotationManager.getSelectedAnnotations()[0];
        if (!selectedAnnotation) return;

        // get all target annotations
        const targetAnnotations = this.target?.getAnnotationList();
        // get the zoneId
        const zoneId = selectedAnnotation.getCustomData(ZoneCustomData.zoneId);
        // same zone id annotations are the ones created via add to zone
        const sameZoneIdAnnotations = targetAnnotations?.filter((annotation) => {
          return (
            annotation.ToolName === PDFTronTools.ZONE && annotation.getCustomData(ZoneCustomData.zoneId) === zoneId
          );
        });
        const zoneGroupId = selectedAnnotation.getCustomData(ZoneCustomData.zoneGroup);
        if (zoneGroupId) {
          // get all the group annotations in target document
          const targetGroupedAnnotations = this._getGroupedAnnotations(instance.Core.annotationManager, zoneGroupId);
          if (targetGroupedAnnotations.length === 1) {
            this._handleSingleUnlink(selectedAnnotation, targetAnnotations);
          } else {
            // delete the selected annotation
            instance.Core.annotationManager.deleteAnnotations([selectedAnnotation], {
              imported: true,
              force: true,
            });
            // if it's not an add-to-zone zone we delete the source zones.
            if (!sameZoneIdAnnotations || sameZoneIdAnnotations.length === 1) {
              // delete source zones that are part of the group
              const sourceAnnotations = this.source?.getAnnotationList().filter((annotation) => {
                return (
                  annotation.ToolName === PDFTronTools.ZONE &&
                  annotation.getCustomData(ZoneCustomData.zoneId) === zoneId
                );
              });
              if (sourceAnnotations && sourceAnnotations.length > 0) {
                this?.source?.annotationManager.deleteAnnotations(sourceAnnotations, { imported: false, force: true });
                store.dispatch(
                  inspection.actions.deleteSelectedZones({
                    documentType: DocumentTypes.source,
                    annotationIds: sourceAnnotations.map((annotation) => annotation.Id),
                  }),
                );
              }
              const allGroupedAnnotations = this._getGroupedAnnotations(instance.Core.annotationManager, zoneGroupId);
              if (allGroupedAnnotations.length > 0) {
                // get the next annotation in the group
                const nextIndex = this._getNextAnnotationIndex(selectedAnnotation, allGroupedAnnotations, 1);
                if (allGroupedAnnotations[nextIndex]) {
                  instance.Core.annotationManager.jumpToAnnotation(allGroupedAnnotations[nextIndex]);
                  instance.Core.annotationManager.selectAnnotation(allGroupedAnnotations[nextIndex]);
                }
              }
              // Update Redux first so shake uses fresh annotation lists
              this.annotationMixin.updateInputAnnotations(false);
              // Renumber only text zones related to this action
              shakeDocumentsZones(selectedAnnotation);
              // Persist renumbered annotations into Redux
              this.annotationMixin.updateInputAnnotations();
            }
          }
        } else {
          if (sameZoneIdAnnotations && sameZoneIdAnnotations.length > 1) {
            // it's a add to zone zone so we only need to delete the selected annotation.
            // delete the selected annotation
            instance.Core.annotationManager.deleteAnnotations([selectedAnnotation], {
              imported: true,
              force: true,
            });
          } else {
            this._handleSingleUnlink(selectedAnnotation, targetAnnotations);
          }
        }
      },
    };
  }

  // sending targetAnnotations by parameter to avoid re-fetching the target annotations
  _handleSingleUnlink(
    selectedAnnotation: Core.Annotations.Annotation,
    targetAnnotations?: Core.Annotations.Annotation[],
  ) {
    // if there is no zone group, we need to prompt the user to create a new zone
    const zoneId = parseInt(selectedAnnotation.getCustomData(ZoneCustomData.zoneId), 10);

    // get the source annotation that's related to the selected annotation
    const sourceAnnotations = this.source?.getAnnotationList();

    // check if there are already unconfirmed zones in the source document
    const unconfirmedZones = sourceAnnotations?.filter((annotation) => {
      return (
        annotation.ToolName === PDFTronTools.ZONE &&
        annotation.getCustomData(ZoneCustomData.confirmed) === 'false' &&
        parseInt(annotation.getCustomData(ZoneCustomData.zoneId), 10) !== zoneId
      );
    });
    if (unconfirmedZones && unconfirmedZones.length > 0) {
      // force view to the already unconfirmed zone
      const sourceSelected = this.source?.instance.Core.annotationManager.getSelectedAnnotations()[0];
      if (sourceSelected) {
        this.source?.annotationManager.deselectAnnotation(sourceSelected);
      }
      // unselect the selected annotation
      this.target?.annotationManager.deselectAnnotation(selectedAnnotation);
      // show popup One at a time ✋
      store.dispatch(
        inspection.actions.setChangeToolError('Please confirm your match before creating or unmatching a new one.'),
      );
      // checking if unconfirmed zone has multiple search candidates
      const unconfirmedZoneSearchCandidates = this.getMultipleSearchResults(unconfirmedZones[0].Id);
      if (unconfirmedZoneSearchCandidates.length === 0) {
        this.promptTextZoneCreation(DocumentTypes.target);
        store.dispatch(
          inspection.actions.activateManualSelection({
            annotationId: unconfirmedZones[0].Id,
            zoneId: parseInt(unconfirmedZones[0].getCustomData(ZoneCustomData.zoneId), 10),
          }),
        );
      }
      // jump to the previous unconfirmed zone for context
      this.source?.annotationManager.jumpToAnnotation(unconfirmedZones[0]);
      // the setTimeout is needed to ensure the annotation is properly selected
      setTimeout(() => {
        this.source?.annotationManager.selectAnnotation(unconfirmedZones[0]);
      }, 50);
    } else {
      // delete the selected annotation
      this.target?.annotationManager.deleteAnnotations([selectedAnnotation], {
        imported: true,
        force: true,
      });
      // mark all the other source zones as readOnly
      sourceAnnotations?.forEach((annotation) => {
        if (
          (annotation.ToolName === PDFTronTools.ZONE || annotation.ToolName === PDFTronTools.MARQUEE_ZONE) &&
          zoneId !== parseInt(annotation.getCustomData(ZoneCustomData.zoneId), 10)
        ) {
          annotation.ReadOnly = true;
          annotation.setCustomData(ZoneCustomData.nonSelectable, 'true');
        }
      });
      // mark all the other target zones as readOnly
      targetAnnotations?.forEach((annotation) => {
        if (
          (annotation.ToolName === PDFTronTools.ZONE || annotation.ToolName === PDFTronTools.MARQUEE_ZONE) &&
          annotation.Id !== selectedAnnotation.Id
        ) {
          annotation.ReadOnly = true;
          annotation.setCustomData(ZoneCustomData.nonSelectable, 'true');
        }
      });

      // reset any add to zone state
      useTextZoneStateStore.getState().setSourceAddToZone(null);
      useTextZoneStateStore.getState().setTargetAddToZone(null);
      this.promptTextZoneCreation(DocumentTypes.target);
      store.dispatch(
        inspection.actions.activateManualSelection({
          annotationId: selectedAnnotation.Id,
          zoneId,
        }),
      );

      // select the source annotation
      const sameZoneIdSourceAnnotations = sourceAnnotations?.filter((annotation) => {
        return (
          annotation.ToolName === PDFTronTools.ZONE &&
          parseInt(annotation.getCustomData(ZoneCustomData.zoneId), 10) === zoneId
        );
      });
      if (sameZoneIdSourceAnnotations && sameZoneIdSourceAnnotations.length > 0) {
        sameZoneIdSourceAnnotations.forEach((annotation) => {
          annotation.setCustomData(ZoneCustomData.confirmed, 'false');
        });
        this.source?.annotationManager.jumpToAnnotation(sameZoneIdSourceAnnotations[0]);
        // the setTimeout is needed to ensure the annotation is properly selected
        setTimeout(() => {
          this.source?.annotationManager.selectAnnotation(sameZoneIdSourceAnnotations[0]);
        }, 50);
      }
      // set documentToast to show the user that the zone was unlinked
      const { setDocumentToast } = useDocumentToastStateStore.getState();
      setDocumentToast(DocumentTypes.source, {
        message: `Unlinked Text Select Zone #${zoneId}. Resolve this zone by either deleting it on the Source document, or creating a matching zone in the Sample document.`,
        type: 'warning',
        expired: false,
      });
    }
  }

  getAddToTextZonePopup(documentType: DocumentTypes, instance: WebViewerInstance) {
    return {
      type: 'actionButton',
      img: '/icons/addToZone.svg',
      title: 'Add To Zone',
      onClick: () => {
        const annotations = instance.Core.annotationManager.getSelectedAnnotations();
        const selectedAnnotation = annotations[0];
        const zoneNumber = parseInt(selectedAnnotation.getCustomData(ZoneCustomData.zoneId), 10);
        if (documentType === DocumentTypes.source) {
          useTextZoneStateStore.getState().setSourceAddToZone({ number: zoneNumber, id: selectedAnnotation.Id });
          useTextZoneStateStore.getState().setTargetAddToZone(null);
          this.promptTextZoneCreation(DocumentTypes.source);
        } else {
          useTextZoneStateStore.getState().setTargetAddToZone({ number: zoneNumber, id: selectedAnnotation.Id });
          useTextZoneStateStore.getState().setSourceAddToZone(null);
          this.promptTextZoneCreation(DocumentTypes.target);
        }
        this.source?.annotationManager.deselectAllAnnotations();
        this.target?.annotationManager.deselectAllAnnotations();
      },
    };
  }

  // function to programatically jump back and forth between zones (supports grouped confirmed and unconfirmed candidates)
  moveToZone(steps: number) {
    if (!this.target || !this.source) return;
    const annotManager = this.target.instance.Core.annotationManager;

    const selectedAnnotation = annotManager.getSelectedAnnotations()[0];
    if (!selectedAnnotation) return;

    const isConfirmed = selectedAnnotation.getCustomData(ZoneCustomData.confirmed) === 'true';
    const isSearchCandidate = selectedAnnotation.getCustomData(ZoneCustomData.zoneSearch) === 'true';

    let candidates: Core.Annotations.Annotation[] = [];
    if (isConfirmed) {
      // Confirmed zones: navigate across grouped annotations
      const zoneGroupId = selectedAnnotation.getCustomData(ZoneCustomData.zoneGroup);
      candidates = this._getGroupedAnnotations(annotManager, zoneGroupId);
    } else if (isSearchCandidate) {
      // Unconfirmed multi-match: navigate across search candidates for the same base id
      const baseId = selectedAnnotation.Id.split('_')[0];
      candidates = this.getMultipleSearchResults(baseId).sort((a, b) => a.PageNumber - b.PageNumber);
    }

    if (candidates.length > 1) {
      const nextIndex = this._getNextAnnotationIndex(selectedAnnotation, candidates, steps);
      const moveToAnnotation = candidates[nextIndex];
      if (moveToAnnotation) {
        annotManager.deselectAnnotation(selectedAnnotation);
        this.target?.instance.Core.annotationManager.jumpToAnnotation(moveToAnnotation);
        setTimeout(() => {
          annotManager.selectAnnotation(moveToAnnotation);
        }, 50);
      }
    }
  }

  getPreviousMatchPopup(disabled: boolean) {
    return {
      type: 'actionButton',
      img: '/icons/leftChevron.svg',
      title: 'Previous Match',
      onClick: () => {
        if (!disabled) {
          this.moveToZone(-1);
        }
      },
    };
  }

  getNextMatchPopup(disabled: boolean) {
    return {
      type: 'actionButton',
      img: '/icons/rightChevron.svg',
      title: 'Next Match',
      onClick: () => {
        if (!disabled) {
          this.moveToZone(1);
        }
      },
    };
  }

  getDeleteZonePopup(instance: WebViewerInstance) {
    return {
      type: 'actionButton',
      img: '/icons/zoneDelete.svg',
      title: 'Delete',
      onClick: () => {
        const manager = PDFManagerFactory.getPDFDocManager();
        if (!manager) return;
        const annotationToDelete = instance.Core.annotationManager.getSelectedAnnotations()[0];
        this.deleteZoneByAnnotation(annotationToDelete);
      },
    };
  }

  // Public helper to delete a zone using the same flow as the delete popup,
  // but operating on an explicit annotation (no reliance on current selection)
  public deleteZoneByAnnotation(
    annotationToDelete: Core.Annotations.Annotation | undefined,
    deleteAllSource: boolean = false,
  ): void {
    if (!annotationToDelete) return;
    if (annotationToDelete.getCustomData(ZoneCustomData.zoneAnnotation) !== 'true') return;

    const annotationId = annotationToDelete.Id;
    const state = store.getState();
    const zoneSelectedArr = getZoneSelectedTexts(state);

    store.dispatch(inspection.actions.deleteSelectedZone({ documentType: DocumentTypes.source, annotationId }));
    PDFAnnotationManager.deleteAnnotationById(DocumentTypes.source, annotationId);
    const annotManager = this.source?.instance.Core.annotationManager;
    annotManager?.deleteAnnotation(annotationToDelete);

    const zoneNumberString = annotationToDelete.getCustomData(ZoneCustomData.zoneId);
    // Gather remaining source zones for this zoneId once
    let otherTextZones = this.source
      ?.getAnnotationList()
      .filter(
        (annot) =>
          annot.ToolName === PDFTronTools.ZONE && annot.getCustomData(ZoneCustomData.zoneId) === zoneNumberString,
      );

    // Optionally delete siblings using the same list, then treat as empty
    if (deleteAllSource && otherTextZones?.length) {
      this.source?.annotationManager.deleteAnnotations(otherTextZones, { imported: false, force: true });
      store.dispatch(
        inspection.actions.deleteSelectedZones({
          documentType: DocumentTypes.source,
          annotationIds: otherTextZones.map((a) => a.Id),
        }),
      );
      otherTextZones = [];
    }

    if (otherTextZones?.length === 0) {
      // if annotation was unconfirmed, we need to expire the unlinked document toast
      if (annotationToDelete.getCustomData(ZoneCustomData.confirmed) === 'false') {
        const { expireAllToast } = useDocumentToastStateStore.getState();
        expireAllToast();
        resetAllNonSelectableFlags();
      }

      this.target?.deleteAllAnnotationsByFilter(
        (annot) =>
          annot.ToolName === PDFTronTools.ZONE &&
          annot.getCustomData(ZoneCustomData.zoneId) === zoneNumberString.toString(),
      );

      // if add to zone was set for this zone, we need to reset it
      if (useTextZoneStateStore.getState().sourceAddToZone?.number === parseInt(zoneNumberString, 10)) {
        useTextZoneStateStore.getState().setSourceAddToZone(null);
      }
      if (useTextZoneStateStore.getState().targetAddToZone?.number === parseInt(zoneNumberString, 10)) {
        useTextZoneStateStore.getState().setTargetAddToZone(null);
        this.promptTextZoneCreation(DocumentTypes.source);
      }
    }

    // Updates annotations in redux
    this.annotationMixin.updateInputAnnotations(false);
    if (zoneSelectedArr.length > 1) {
      shakeDocumentsZones(annotationToDelete);
    }

    store.dispatch(
      inspection.actions.deleteSelectedText({
        documentType: DocumentTypes.source,
        annotationId: annotationToDelete.Id,
      }),
    );
    this.annotationMixin.updateInputAnnotations();

    const manualSelectedZoneId = getManualSelectedZoneId(store.getState());
    if (manualSelectedZoneId) {
      // deactivate manual selection state in case the manually selected zone was deleted
      store.dispatch(inspection.actions.deactivateManualSelection());
      PDFTronManager.setToolMode(PDFTronTools.ZONE);
      PDFManagerFactory.getViewer(DocumentTypes.source)?.addDocumentHighlight();
      PDFManagerFactory.getViewer(DocumentTypes.target)?.removeAnnotationDocumentHighlight();
    }
  }

  private _getGroupedAnnotations(
    annotManager: Core.AnnotationManager,
    zoneGroupId: string | null | undefined,
  ): Core.Annotations.Annotation[] {
    if (!zoneGroupId) {
      return [];
    }
    return annotManager
      .getAnnotationsList()
      .filter((annotation) => {
        const isInGroup = annotation.getCustomData(ZoneCustomData.zoneGroup) === zoneGroupId;
        const isConfirmed = annotation.getCustomData(ZoneCustomData.confirmed) === 'true';
        return annotation.ToolName === PDFTronTools.ZONE && isInGroup && isConfirmed;
      })
      .sort((annotationA, annotationB) => annotationA.PageNumber - annotationB.PageNumber);
  }

  private _getNextAnnotationIndex(
    currentAnnotation: Core.Annotations.Annotation,
    allAnnotations: Core.Annotations.Annotation[],
    steps: number,
  ): number {
    // Find the index of the selected annotation
    const currentIndex = allAnnotations.findIndex(
      (annotation) => annotation.ToolName === PDFTronTools.ZONE && annotation.Id === currentAnnotation.Id,
    );

    // Calculate the next index with wrapping
    return (currentIndex + steps + allAnnotations.length) % allAnnotations.length;
  }

  // Safely extract quads from an annotation. Works even if getQuads is not present.
  private getQuadsSafe(annot: Core.Annotations.Annotation): any[] {
    const anyAnnot = annot as any;
    try {
      if (typeof anyAnnot?.getQuads === 'function') {
        const q = anyAnnot.getQuads();
        return Array.isArray(q) ? q : [];
      }
      // in WebViewer some annotations expose quads only via the Quads property
      if (Array.isArray(anyAnnot?.Quads)) return anyAnnot.Quads as any[];
    } catch (_) {
      // ignore and fall through
    }
    return [];
  }

  private promptTextZoneCreation(documentType: DocumentTypes) {
    const activeDocument = PDFManagerFactory.getViewer(documentType);
    const inactiveDocument = PDFManagerFactory.getViewer(
      documentType === DocumentTypes.source ? DocumentTypes.target : DocumentTypes.source,
    );
    if (!activeDocument || !inactiveDocument) {
      return;
    }

    activeDocument.addDocumentHighlight();
    activeDocument.setTool(PDFTronTools.ZONE);
    inactiveDocument.removeAnnotationDocumentHighlight();
    inactiveDocument.setTool(PDFTRON_DEFAULT_TOOL);

    // Update Redux store to reflect the tool selection in the UI
    store.dispatch(inspection.actions.setSelectedTool({ tool: PDFTronTools.ZONE }));
  }
}

export default TextZone;
